<template>

  <slot name="before-page"/>

  <stihl-header v-show="isNotInIframe" ref="header" />

  <div :id="id" class="page-wrapper">
    <slot />
  </div>

  <stihl-footer v-show="isNotInIframe" />

  <slot name="after-page"/>

</template>

<script lang="ts">
import StihlHeader from './StihlHeader.vue';
import StihlFooter from './StihlFooter.vue';

export default {
  name: 'PageTemplate',
  components: { StihlHeader, StihlFooter },
  computed: {
    isNotInIframe() {
      return window.self === window.top;
    },
  },
  props: {
    id: { type: String, required: true },
  },
};
</script>
